import React, { useState } from "react";
import "./Tabs.scss";

/**
 * Componente de pestañas que permite navegar entre diferentes secciones de contenido
 * @param {boolean} isDisabled - Deshabilita toda interacción con las pestañas
 * @param {Array} items - Array de objetos de pestaña con propiedad label
 * @param {number} activeTab - Índice de la pestaña actualmente activa (1-based: 1, 2, 3...)
 * @param {Function} onChange - Función callback que se ejecuta cuando cambia la pestaña (recibe índice 1-based)
 * @param {string} className - Clases CSS adicionales
 * @param props - Otros props que se pasan al componente
 */
export const Tabs = ({
  isDisabled = false,
  items = [],
  activeTab,
  onChange,
  className = "",
  ...props
}) => {
  const [internalActiveTab, setInternalActiveTab] = useState(1);
  const currentActiveTab =
    activeTab !== undefined ? activeTab : internalActiveTab;

  const handleTabClick = (tabIndex) => {
    if (isDisabled) return;

    if (activeTab === undefined) {
      setInternalActiveTab(tabIndex);
    }

    onChange?.(tabIndex);
  };

  return (
    <div className={`tabs ${className}`} {...props}>
      <div className="tabs__list">
        {items.map((item, index) => {
          const tabIndex = index + 1;
          return (
            <button
              key={tabIndex}
              className={`tabs__tab ${
                currentActiveTab === tabIndex ? "tabs__tab--active" : ""
              }`}
              onClick={() => handleTabClick(tabIndex)}
              disabled={isDisabled}
              type="button"
            >
              {item.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
